import { getGroupByID, getScaleByID } from '@/services/firebase'
import { isValidDuty, apiGetUserShiftsBetweenTwoDates } from '@/services/duties'
import { valueToTime } from '@/functions'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

// Carregar todos os plantões do grupo dentro do mês selecionado
// Carregar todos os plantões do grupo dentro do mês atual no calendário

/*

      //
      //
      //
      // ------------------------------------------------------------------------
      // CONFLITOS (BEGIN)
      // ------------------------------------------------------------------------
      //
      //
      //

      // [24/01/25] console.log('::: DETALHES DO PLANTÃO -> SAVE -> ID:', this.plantaoID)
      // [24/01/25] console.log('::: DETALHES DO PLANTÃO -> SAVE -> [OLD, NEW] VALUE:', plantaoValor, campoValor)
      // [24/01/25] console.log('::: DETALHES DO PLANTÃO -> SAVE -> [OLD, NEW] OBSERVATION:', plantaoObservacao, campoObservacao)
      // [24/01/25] console.log('::: DETALHES DO PLANTÃO -> SAVE -> [OLD, NEW] OWNER:', this.plantonistaID, this.campoPlantonistaSelecionado)
      // [24/01/25] console.log('::: DETALHES DO PLANTÃO -> SAVE -> PROGRESS:', this.dutyProgressStatus)

      if (selectedNewOwner)
      {
        const conflictedScales = []

        const dutyStartDate = this.isNewTZ ? moment.utc(this.plantaoDataInicio) : moment(this.plantaoDataInicio)
        const dataInicioPlantao = dutyStartDate.format('YYYY-M-D')

        //
        // Carregar todos os plantões do grupo dentro do mês atual no calendário

        const plantoesDoUsuario = await apiGetUserShiftsBetweenTwoDates(this.campoPlantonistaSelecionado, this.firstDate, this.lastDate)
        const shiftsKeys = plantoesDoUsuario ? Object.keys(plantoesDoUsuario) : []

        //
        // Filtra pelo scaleName e scaleLocation

        if (shiftsKeys.length > 0)
        {
          shiftsKeys.forEach(shiftID => {
            const shift = plantoesDoUsuario[shiftID]

            if (
              !!plantoesDoUsuario[shiftID] === true &&
              isValidDuty(shift) &&
              shift.uid_pegou === this.campoPlantonistaSelecionado &&
              shift.groupID === this.groupID
            ) {
              const startDate = ((shift.dutyStartDateTZ || '') === '+0000' ? moment.utc(shift.data_inicio) : moment(shift.data_inicio)).format('YYYY-M-D')

              if (startDate === dataInicioPlantao && shift.hora_inicio === this.plantaoHoraInicio)
              {
                const scaleFound = this.listeners.groupScales.find(scale => scale.scaleID === shift.scaleID)
                const scaleName = !!scaleFound && !!scaleFound.scaleName ? scaleFound.scaleName : shift.scaleID

                if (!conflictedScales.some(conflict => conflict === scaleName)) {
                  conflictedScales.push(scaleName)
                }
              }
            }
          })
        }

        //
        // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário

        if (conflictedScales.length > 0)
        {
          let conflictsHtml = ''

          conflictedScales.forEach(scale => {
            conflictsHtml += `<br /><b style="color: indianred">${scale}</b><br />`
          })

          const foundDoctorInGroup = this.campoPlantonistaOpcoes.find(user => user.value === this.campoPlantonistaSelecionado)
          const usuarioSelecionadoText = !!foundDoctorInGroup === true ? `<b style="color: #778899">${foundDoctorInGroup.text}</b>` : 'O usuário selecionado'

          const title = 'Conflito!'
          const text = `<div style="text-align: center">${usuarioSelecionadoText} já tem um plantão no grupo nesse mesmo dia e horário.<br /><br />Veja as escalas abaixo e resolva os conflitos para continuar:<br />${conflictsHtml}</div>`

          this.cdParameters.title = title
          this.cdParameters.text = text
          this.$refs.cdConfirmModal.open({ cdType: 'message', cdData: { title, text } }, false)

          return false
        }
      }

      //
      //
      //
      // ------------------------------------------------------------------------
      // CONFLITOS (END)
      // ------------------------------------------------------------------------
      //
      //
      //

*/

//
//
//
// canAddUserShift
//
//
//

//
// const scaleFound = groupScales.find(scale => scale.scaleID === shift.scaleID)

// const scaleName = !!scaleFound && !!scaleFound.scaleName ? scaleFound.scaleName : shift.scaleID
// const scaleName = ''

// shift.scaleID
// shift.groupID

// TESTAR CONFLITOS EM DOIS GRUPOS/ESCALAS DIFERENTES, MAS COM NOMES IGUAIS...

//
// shift.uid_pegou === plantaoPlantonistaID // &&
// shift.groupID === groupID
//

const canAddUserShift = async (startTime = '', dates = [], /* groupScales = [], groupID = '', */ plantaoPlantonistaID = '', firstDate = null, lastDate = null) => {
  const conflictedDates = []
  let conflictedScales = []

  //
  // Carregar todos os plantões do grupo dentro do período informado

  const plantoesDoUsuario = await apiGetUserShiftsBetweenTwoDates(plantaoPlantonistaID, firstDate, lastDate)
  const shiftsKeys = plantoesDoUsuario ? Object.keys(plantoesDoUsuario) : []

  //
  // LER NOME DAS ESCALAS AQUI
  //

  /* const plantoes = shiftsKeys.length > 0 ? await Promise.all(
    shiftsKeys.map(async userID => await getUserByID(userID)).filter(userID => userID && typeof userID === 'object')
  ) : [] */

  //
  //
  //

  //
  // Filtra pelo scaleName e scaleLocation

  if (shiftsKeys.length > 0)
  {
    //
    // ?
    //
    // Nota:
    // Testar fuso horário?
    //

    shiftsKeys.forEach(shiftID => {
      const shift = plantoesDoUsuario[shiftID]

      if (
        !!plantoesDoUsuario[shiftID] === true &&
        isValidDuty(shift) &&
        shift.uid_pegou === plantaoPlantonistaID
      ) {
        const startDate = ((shift.dutyStartDateTZ || '') === '+0000' ? moment.utc(shift.data_inicio) : moment(shift.data_inicio)).format('DD/MM/YYYY')

        if (
          dates.some(date => date === startDate) && valueToTime(shift.hora_inicio) === startTime
        ) {
          if (
            !conflictedDates.some(conflictDate => conflictDate.scaleID === shift.scaleID && conflictDate.date === startDate)
          ) {
            conflictedDates.push({ date: startDate, scaleID: shift.scaleID })

            if (
              !conflictedScales.some(conflictedScale => conflictedScale.scaleID === shift.scaleID)
            ) {
              conflictedScales.push({
                scaleID: shift.scaleID,
                scaleName: '',
                groupID: shift.groupID,
                groupName: '',
              })
            }
          }
        }
      }
    })
  }

  //
  //
  //

  conflictedScales = conflictedScales.length > 0 ? await Promise.all(
    conflictedScales.map(async conflictedScale => {
      let scaleName = conflictedScale.scaleName
      let groupName = conflictedScale.groupName

      if (groupName.length === 0) {
        const group = await getGroupByID(conflictedScale.groupID)
        groupName = !!group && Object.prototype.hasOwnProperty.call(group, 'nome') && group.nome.trim().length > 0 ? group.nome.trim() : ''
      }

      if (scaleName.length === 0) {
        const scale = await getScaleByID(conflictedScale.groupID, conflictedScale.scaleID)
        scaleName = !!scale && Object.prototype.hasOwnProperty.call(scale, 'type') && scale.type.trim().length > 0 ? scale.type.trim() : ''
      }

      return conflictedScale.scaleName.length === 0 || conflictedScale.groupName.length === 0 ? { ...conflictedScale, scaleName, groupName } : conflictedScale
    })
  ) : []

  //
  //
  //

  let conflictsTableHtml = '<table class="tableConflicts">'
  conflictsTableHtml += '<tr><th style="padding: 0 5px 0 7px;">Escala</th><th style="padding: 0 5px 0 7px;">Datas</th></tr>'

  conflictedScales.forEach(scale => {
    conflictsTableHtml += '<tr>'
    conflictsTableHtml += `<td style="padding: 4px 5px 7px 7px; line-height: 0; word-break: break-all"><b style="color: indianred; line-height: 19px">${scale.scaleName}</b><span style="display: inline-block; width: 100%; font-size: 14px; line-height: 14px">Grupo: <span style="color: slategrey">${scale.groupName}</span></td>`

    // Datas por escala
    conflictsTableHtml += '<td style="font-size: 14px; font-weight: 600; line-height: 1; white-space: nowrap">'
    conflictedDates.forEach(date => {
      if (date.scaleID === scale.scaleID) conflictsTableHtml += `${date.date}<br />`
    })

    conflictsTableHtml += '</td>'
    conflictsTableHtml += '</tr>'
  })

  conflictsTableHtml += '</table>'

  //
  //
  //

  return { conflictedDates, conflictedScales, conflictsTableHtml }
}

//
//
//
// EXPORT
//
//
//

export default canAddUserShift
